export default {"src":"/_next/static/media/CHWY.410f2ade.svg","height":18,"width":18};